import { useMemo } from "react";
/**
 * Build dictionaries for program meals and products.
 * @param programMeals store.model.Program.ProgramMeals
 * @param products store.model.Products
 * @returns Object containing programMealDictionary and productDictionary
 */
export const buildMealAndProductDictionaries = (programMeals, products) => {
    // Create dictionary for ProgramMeals.
    // This is used to get the name of the meal from the ProgramMealId.
    const programMealDictionary = useMemo(() => {
        const dictionary = {};
        programMeals.forEach((meal) => {
            dictionary[meal.ProgramMealId] = { mealName: meal.MealName, mealId: meal.ProgramMealId };
        });
        return dictionary;
    }, [programMeals]);
    // Create a dictionary for Products.
    // This is used to get the name of the product from the ProductId.
    const productDictionary = useMemo(() => {
        const dictionary = {};
        products.forEach((product) => {
            dictionary[product.productId] = { productName: product.productName, productId: product.productId };
        });
        return dictionary;
    }, [products]);
    return { programMealDictionary, productDictionary };
};
